import React from 'react';
import {
  CardWrapper, CardInner, ColoredIcon, HeroText, RelatedText,
  TextWrapper, ClickableIcon, DescriptiveText,
} from './style';

// If the prefix/suffix related prop is a string, add to the text as a string,
// if is an object, the current version only supports coloured icons.
const prefixAndSuffixRenderer = (value) => {
  if (!value) {
    return null;
  }
  return (typeof value === 'string') ? value
    : (value.icon && (
    <ColoredIcon
      type={value.icon}
      color={value.color}
    />
    ));
};
// TODO: For better demo purpose, we have temporary disable the delta description.
const InfoCard = ({ data, onCardClick, active }) => {
  const {
    value, prefix = '', suffix = '', relate, descriptionPrefix = '', description = '', descriptionSuffix = '', color = 'clientPrimary',
  } = data;

  return (
    <CardWrapper
      onClick={onCardClick}
      color="greyscale.1"
      py={2}
      px={2}
      hoverColor={color}
      active={active}
    >
      <div
        className="DCRPCard"
      >
        <CardInner>
          <TextWrapper>
            <HeroText color={color} fontSize={['.55em', '1.25em', '2em']}>
              {prefixAndSuffixRenderer(prefix)}
              {value && value.toLocaleString()}
              {prefixAndSuffixRenderer(suffix)}
            </HeroText>
            <RelatedText pl={0} fontSize={['0.5em', '0.75em', '1em']}>
              {relate && relate.toUpperCase()}
            </RelatedText>
          </TextWrapper>
        </CardInner>
        <DescriptiveText
          color="greyscale.2"
          fontSize={['0.45em', '0.65em', '0.95em']}
          mt="6px"
        >
          {prefixAndSuffixRenderer(descriptionPrefix)}
          {description}
          {prefixAndSuffixRenderer(descriptionSuffix)}
        </DescriptiveText>
        {onCardClick && <ClickableIcon type="fund" />}
      </div>
    </CardWrapper>
  );
};

export default InfoCard;
